import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import _isEqual from 'lodash/isEqual';
import { useIntl } from 'react-intl';

// State
import {
  addToCart,
  cancelRemovedIngredients,
  removeIngredient,
} from '../../state/modules/catalog/actions';
import { showFreeSaucesPanel } from '../../state/modules/freeSauces/actions';

// Components
import Heading from '../Heading';
import CreatePizzaCard from '../CreatePizzaCard';
import HalvesCard from '../HalvesCard';
import PizzaFilter from '../PizzaFilter';
import ProductCard from '../ProductCard';
import ProductCardCompact from '../ProductCardCompact';

// Styles
import styles from './ProductList.styl';

const cx = classNames.bind(styles);

export default function ProductList(props) {
  const { className, category, list, isHiddenActions } = props;

  const intl = useIntl();
  const dispatch = useDispatch();
  const isPhone = useSelector(state => state.responsive.isPhone);

  const goods = list.filter(good => good.category_id === category.id);

  const [filterPizzaGoodsIds, setFilterPizzaGoodsIds] = useState(
    goods.map(filteredGood => filteredGood.id),
  );

  const filtredGoods =
    category.alias === 'pizza'
      ? goods.filter(good => filterPizzaGoodsIds.includes(good.id))
      : goods;

  const removeIngredientAction = ({ id, variation, ingredientId }) => {
    return dispatch(removeIngredient(id, variation.id, ingredientId));
  };

  const cancelRemovedIngredientsAction = ({ id, variation }) => {
    return dispatch(cancelRemovedIngredients(id, variation.id));
  };

  const addToCartAction = ({ goodId, variation, stockCode }) => {
    const addToCartWithSauce = async () => {
      await dispatch(addToCart(goodId, [{ type: 'good', item: variation }]));

      if (variation.sauces?.length > 0) {
        await dispatch(
          showFreeSaucesPanel(variation.id, variation.sauces, variation.free_sauce_count),
        );
      }
    };

    return addToCartWithSauce();
  };

  const changeFilterPizza = ids => {
    // чтобы первоначальный рендеринг не происходил дважды
    if (!_isEqual(filterPizzaGoodsIds, ids)) {
      setFilterPizzaGoodsIds(ids);
    }
  };

  const renderCard = good => {
    const cardClassName = cx('ProductList__item', {
      ProductList__item_constructor: good.alias === 'sozday',
      ProductList__item_halves: good.alias === 'halves',
    });

    switch (good.alias) {
      case 'sozday': {
        if (isHiddenActions) {
          return null;
        }

        return (
          <CreatePizzaCard key={good.id} className={cardClassName} name={good.name} id={good.id} />
        );
      }
      case 'halves': {
        if (isHiddenActions) {
          return null;
        }

        return <HalvesCard key={good.id} className={cardClassName} name={good.name} />;
      }
      default: {
        return isPhone ? (
          <ProductCardCompact
            key={good.id}
            className={cardClassName}
            good={good}
            isHiddenActions={isHiddenActions}
            removeIngredientAction={removeIngredientAction}
            cancelRemovedIngredientsAction={cancelRemovedIngredientsAction}
            addToCartAction={addToCartAction}
          />
        ) : (
          <ProductCard
            key={good.id}
            className={cardClassName}
            good={good}
            isFromProductList
            isHiddenActions={isHiddenActions}
            removeIngredientAction={removeIngredientAction}
            cancelRemovedIngredientsAction={cancelRemovedIngredientsAction}
            addToCartAction={addToCartAction}
          />
        );
      }
    }
  };

  return (
    <div className={cx('ProductList', className)} id={category.alias}>
      {category.alias === 'pizza' ? (
        <PizzaFilter name={category.name} changeFilterPizza={changeFilterPizza} goods={goods} />
      ) : (
        <Heading className={cx('ProductList__heading')} level={4}>
          {category.name}
        </Heading>
      )}
      <div className={cx('ProductList__list', { ProductList__list_disabled: isHiddenActions })}>
        {filtredGoods.map(good => renderCard(good))}
      </div>
    </div>
  );
}

ProductList.defaultProps = {
  className: '',
  isHiddenActions: false,
};

ProductList.propTypes = {
  className: PropTypes.string,
  category: PropTypes.object.isRequired,
  list: PropTypes.array.isRequired,
  isHiddenActions: PropTypes.bool,
};
